import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { api, ler } from "../api.ts";
import { Cabecalho, Carregando, dataHora, ErroCarga, Selo, Tabela, Vazio } from "../ui.tsx";

export function PaginaCompras() {
  const [semConta, setSemConta] = useState(false);
  const { data, error } = useQuery({
    queryKey: ["compras", semConta],
    queryFn: () => ler(api.compras.$get({ query: { semConta: semConta ? "1" : undefined } })),
  });
  return (
    <>
      <Cabecalho
        titulo="Compras"
        sub="Recebidas pelos webhooks da Kiwify e da Kavoo. O acesso segue o CPF, vinculado quando o usuário o informa no app."
      />
      <label className="flex min-h-9 items-center gap-2 self-start text-sm">
        <input type="checkbox" className="size-4 accent-primary" checked={semConta} onChange={(e) => setSemConta(e.target.checked)} />
        Só compras sem conta vinculada
      </label>
      {error ? (
        <ErroCarga erro={error} />
      ) : !data ? (
        <Carregando />
      ) : !data.length ? (
        <Vazio>Nenhuma compra.</Vazio>
      ) : (
        <Tabela>
          <thead>
            <tr>
              <th>Data</th>
              <th>Provedor</th>
              <th>Produto</th>
              <th>Comprador</th>
              <th>Status</th>
              <th>Conta</th>
            </tr>
          </thead>
          <tbody>
            {data.map((c) => (
              <tr key={c.id}>
                <td className="whitespace-nowrap text-xs">{dataHora(c.criadoEm)}</td>
                <td className="text-xs">
                  {c.provedor}
                  <div className="font-mono text-muted">{c.pedidoId}</div>
                </td>
                <td className="text-xs">
                  {c.produtoNome ?? "—"} {c.plano === "padrao" ? null : <Selo tom="destaque">{c.plano}</Selo>}
                </td>
                <td className="text-xs">
                  {c.email ?? "—"}
                  <div className="font-mono text-muted">CPF •••{c.cpfFinal ?? "??"}</div>
                </td>
                <td>
                  <Selo tom={c.ativo ? "ok" : "neutro"}>{c.ativo ? "ativa" : c.status}</Selo>
                </td>
                <td className="text-xs">
                  {c.usuarioId ? (
                    <Link to="/usuarios/$id" params={{ id: c.usuarioId }} className="font-semibold text-primary">
                      ver conta
                    </Link>
                  ) : (
                    <span className="text-muted">sem conta</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Tabela>
      )}
    </>
  );
}
